import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import {
	Button,
	OverlayTrigger,
	Tooltip
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { AiOutlineWarning } from "react-icons/ai";
import { BiPencil, BiPlus } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { LoaderContext, RegulationContext } from "../../../../App";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import Pagination from "../../../../components/Pagination/Pagination";
import { DEFAULT_ITEMS_PER_PAGE, LS_AUTHORITY_KEY, STATUS, SORT_ORDER_DESC } from "../../../../core/constants/common";
import DataCollectionEventService from "../../../../core/service/DataCollectionEventService";
import Utils from "../../../../core/utilities/Utils";
import assessment_pic from "../../../../images/Assessment.png";
import "../Forms.scss";
import QualitativeDCEModal from "../NewAssessmentModal/QualitativeDCEModal";
import { BsFillCircleFill } from "react-icons/bs";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import useHasPermission from "../../../../core/hooks/useHasPermission";

const DCE_CARD_NAME_PREFIX = 'Qualitative Data Collection - ';

function QualitativeDCEList({ t, updatedOn, searchKey }) {
	const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
	const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
	const lsData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const location = useLocation();
	const [showModal, setShowModal] = useState(location?.state?.startNew ? true : false);
	const [showModalQual, setShowModalQual] = useState(false)
	const [itemsTotalCount, setItemTotalCount] = useState(0);
	const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
	const [currentPage, setCurrentPage] = useState(1);
	const [dce, setDCE] = useState([])
	const [sharedQualId, setSharedQualitativeId] = useState(0);
	const [editedQualitativeId, setEditedQualitativeId] = useState(0);
	const [duplicatedAssessmentId, setDuplicatedAssessmentId] = useState(0);
	const [permBubble, setPermBubble] = useState(false)
	const navigate = useNavigate();
	const { loaderDisplay, setLoaderDisplay } = useContext(LoaderContext);
	const [sortField, setSortField] = useState('reportingPeriod');
	const [order, setOrder] = useState(SORT_ORDER_DESC);
	const { hasDataCollectionUpdatePermission } = useHasPermission();
	useEffect(() => {
		getQualitativeDCE(0, itemsPerPage, sortField,
			order);
	}, [glbRegulationId]);

	useEffect(() => {
		if (updatedOn === 0) return;

		getQualitativeDCE(0, itemsPerPage, sortField, order);
	}, [updatedOn]);

	const getQualitativeDCE = (pageNumber, itemsPerPageVal, sortField,
		orderVal) => {
		const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
		if (pageNumber > 0) {
			pageNumber = pageNumber - 1;
		} else {
			setCurrentPage(1);
		}
		const perPage = itemsPerPageVal > 0 ? itemsPerPageVal : itemsPerPage;
		const sort = sortField + "," + orderVal;
		setLoaderDisplay(true);
		if (!glbRegulationId) return;

		DataCollectionEventService.listDCE(pageNumber, perPage, sort, glbRegulationId)
			.then((response) => {
				setLoaderDisplay(false);
				setItemTotalCount(parseFloat(response.headers["x-total-count"]));
				setDCE([...response.data]);
			})
			.catch((error) => {
				setLoaderDisplay(false);
			});
	};

	const onShareAssessment = (confirmed) => {
		if (!confirmed) {
			setSharedQualitativeId(0);
			return;
		}
		DataCollectionEventService.shareDCE(sharedQualId).then(res => {
			setSharedQualitativeId(0);
			if (res.status !== 200) return;

			toast.success("Success", {
				position: toast.POSITION.TOP_RIGHT,
			});
			getQualitativeDCE(currentPage, itemsPerPage, sortField, order)
		}).catch((error) => { setSharedQualitativeId(0); });
	};

	const openSubmissions = (form) => {
		navigate(`/company_admin/assessments/${form.id}/submissions/true`, {
			state: {
				assessmentName: `Qualitative Question - ${moment(form?.period).format("MMMM, YYYY")}`,
				qual: true,
				id: form.id
			},
		});
	};

	const blankCardToRender = () => {
		return (
			<div className="Assessment_blankcard">
				<div>
					<div className="assessment_pic">
						<img src={assessment_pic} />
					</div>
					<h4 className="mb-4">{t('SelfAssessmentBlankHeader1.label')}</h4>
					<Button variant="primary" hidden={!hasDataCollectionUpdatePermission()} className="px-3" onClick={() => {
						setShowModal(true)
						setShowModalQual(true)
					}}>
						<BiPlus className="mr-2" /> {t("New.label")}
					</Button>
				</div>
			</div>
		);
	};

	const QualitativeListCardToRender = (form, index) => {
		const lastSubmissionDate = new Date(form.lastSubmissionDate);
		const isExpired = lastSubmissionDate < new Date();
		let percentage = 0;
		if (form.sharedOn) {
			percentage = ((form.progressCount['COMPLETED'] ?? 0) / (form.progressCount['TOTAL'] ?? 1)) * 100;
		}
		let topicCount = 0, questionCount = 0;
		form.permissions?.forEach(perm => {
			if (perm.topic?.id > 0) {
				topicCount++;
			}
			if (perm.question?.id > 0) {
				questionCount++;
			}
		});
		const showInProgressBadge =
			(form.sharedOn && !isExpired && (form.progressCount['COMPLETED'] !== form.progressCount['TOTAL']));
		const showCompletedBadge = form.sharedOn
			&& form.progressCount['COMPLETED'] === form.progressCount['TOTAL']
			&& !isExpired;
		let uniqueUsers = [];
		form.permissions.forEach(p => {
			p.users?.forEach(u => {
				if (uniqueUsers?.indexOf(u.id) >= 0) return;

				uniqueUsers.push(u.id);
			});
		})
		return (
			<div className="card mb-2" key={`assessment-form-card-${index + 1}`}>
				<div className="card-body pb-1">
					<div className="row m-0">
						<div className="col-lg-6 col-md-12 p-2">
							<div className="row m-0">
								<div className="col-lg-11 col-md-11 p-0">
									<div>
										<h5 className="cursor" onClick={() => openSubmissions(form)}>
											{DCE_CARD_NAME_PREFIX + moment(form?.period).format("YYYY")}
										</h5>
									</div>

									<div className="from_data">
										<small>
											<div>
												<ul>
													<li>{topicCount} {t('Topics.label')}</li>
													<li>{questionCount} {t('Questions.label')}</li>
												</ul>
											</div>
										</small>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-2 col-md-4 col-sm-4 p-2 Reporting_PeriodBox">
							<div className="mb-3">
								<span>{t('ReportingPeriod.label')}</span>
								<div>
									<b>{Utils.reportingPeriodToReadableText(form.period, 'ANNUAL', t)}</b>
								</div>
							</div>
							<div>
								<span>{t('ExpiryDate.label')}</span>
								<div>
									<b>
										{form?.lastSubmissionDate ? moment(form?.lastSubmissionDate).format("MMM DD, YYYY") : ''}
									</b>
								</div>
							</div>
						</div>
						<div className="col-lg-2 col-md-4 col-sm-4 p-2">
							{renderSharedWithDetails(form)}
						</div>
						<div className="col-lg-2 col-md-4 col-sm-4 p-2">
							<div className="Form_SubmitDts">
								<ul>
									<li>
										<BsFillCircleFill className="text-Medium" />
										<div className="Form_status1">{STATUS.SUBMITTED}</div>
										<b>{form.progressCount['COMPLETED'] ?? 0}</b>
									</li>
									<li>
										<BsFillCircleFill className="text-High" />
										<div className="Form_status1">{STATUS.IN_PROGRESS}</div>
										{/* <b>{form.sharedOn ? (form.progressCount['TOTAL'] - form.progressCount['COMPLETED']) ?? 0 : 0}</b> */}
										<b>
											{form.sharedOn
												? ((form.progressCount?.TOTAL ?? 0) - (form.progressCount?.COMPLETED ?? 0))
												: 0}
										</b>

									</li>
									<li>
										<BsFillCircleFill className="text-Low" />
										<div className="Form_status1">{STATUS.NOT_SHARED}</div>
										<b>{form.sharedOn ? 0 : uniqueUsers?.length}</b>
									</li>
								</ul>
							</div>
						</div>
						<div className="Assessment_percentagebox">
							<CircularProgressbar
								value={percentage.toFixed(0)}
								text={`${percentage.toFixed(0)}%`}
								styles={buildStyles({
									pathColor: '#0d6efd',
									textColor: '#000',
									trailColor: '#dee8ed'
								})}
							/>
						</div>
					</div>
				</div>
				<div className="card-footer">
					<div className="AsessmentCard_footer">
						<div className="Assessment_Foot_in">
							{!form.sharedOn && !isExpired && (
								<span className="badge bg-badge-New rounded-pill">Not Started</span>
							)}

							{showInProgressBadge && (
								<span className="badge bg-badge-Inprogress rounded-pill">In Progress</span>
							)}

							{showCompletedBadge && (
								<span className="badge bg-badge-Finalized rounded-pill">Completed</span>
							)}

							{form.lastSubmissionDate && new Date(form.lastSubmissionDate) < new Date() && (
								<span className="badge bg-badge-Inactive rounded-pill">Expired</span>
							)}
							{!form.sharedOn && (
								<Button
									variant={`${form.sharedOn ? 'secondary' : 'primary'}`}
									className="px-4 ms-2"
									onClick={() => setSharedQualitativeId(form.id)}>

									{!form.sharedOn && t("Share.label")}
								</Button>
							)}
							{form.sharedOn && (
								<Button variant="secondary"
									className="px-4 ms-2"
									onClick={() => openSubmissions(form)} >
									Responses
								</Button>
							)}
						</div>
						<div className="Assessment_Foot_in02">
							{
								form.assessmentForm?.status === 'DRAFT' &&
								<OverlayTrigger
									placement="auto"
									overlay={<Tooltip>{t('FormNotPublishedTooltip.label')}</Tooltip>} >
									<span className="badge bg-badge-Critical rounded-pill"><AiOutlineWarning /> {t('FormNotPublished.label')}</span>
								</OverlayTrigger>

							}

							<Button className="px-2"
								variant="blank_outline"
								onClick={() => {
									setShowModalQual(true); setPermBubble(false);
									setEditedQualitativeId(form.id);

								}}>
								<BiPencil />
							</Button>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const renderSharedWithDetails = (form) => {
		const days = form.remindBefore == 0 ? form.remindBefore + 1 : form.remindBefore;
		const lastDate = new Date(form.lastSubmissionDate);
		let totaldays = null;
		totaldays = days === null ? 1 : days;
		const tenDaysBefore = new Date(lastDate);
		tenDaysBefore.setDate(lastDate.getDate() - totaldays);
		const formattedDate = tenDaysBefore.toISOString().split('T')[0];
		return (
			<div className="Share_withCard 2">
				<span>{t('Permissions.label')}</span>
				<div className="mb-3">
					<ul>{renderPermissionBubbles(form)}</ul>
				</div>
				{
					form.reminderEnabled
						?
						<div><span>Occurs every {form.daysOffset} day(s) from  {moment(formattedDate).format("MMMM DD, YYYY")}</span></div>
						:
						<div><span>{t("NoReminder.label")}</span></div>
				}
			</div>
		);
	};

	const renderPermissionBubbles = (form) => {
		let permCount = 0;
		const elements = [];
		const permittedUsers = [];
		form.permissions?.forEach((perm, pIndex) => {
			perm?.users?.forEach((user, uIndex) => {
				if (permittedUsers?.findIndex(u => u.id === user.id) >= 0) return;

				if (permCount >= 3) return;

				permittedUsers.push(user);
				elements.push(
					<li key={`assmtSharedGroup-${uIndex}-${uIndex}`} onClick={() => {
						setShowModalQual(true);
						setEditedQualitativeId(form.id);
						setPermBubble(true)
					}}>
						{Utils.getTextBasedProfilePic(user.name)}
					</li>
				);
				permCount++;
			});
		});
		if (permCount > 3) {
			elements.push(<li key='shareCountKey' className="Share_count" onClick={() => {
				setShowModalQual(true);
				//setEditedQualitativeId(form.id);
				setPermBubble(true)
			}}>+{permCount - 3}</li>);
		}
		return elements;
	};

	return (
		<>
			<div className="FormsList">
				<div className="List_Table_01 mt-2">
					<div className='Assessment_Company'>
						{!loaderDisplay && dce.length === 0 && blankCardToRender()}
						{
							!loaderDisplay && dce.length > 0 &&
							<div className='Assessment_Company_listbox'>
								{
									dce.map((item, index) => {
										return QualitativeListCardToRender(item, index);
									})
								}
							</div>
						}
					</div>
					{
						dce?.length > 0 &&
						<div className="p-2 List_footer_count">
							<Pagination
								itemsTotalCount={itemsTotalCount}
								itemsPerPage={itemsPerPage}
								currentPage={currentPage}
								setCurrentPage={setCurrentPage}
								alwaysShown={true}
								setItemsPerPage={setItemsPerPage}
								pageClicked={(pageNum, perPage) => {
									getQualitativeDCE(pageNum, perPage, sortField, order);
								}}
							/>
						</div>
					}
				</div>
			</div >
			{
				showModalQual &&
				<QualitativeDCEModal
					id={editedQualitativeId > 0 ? editedQualitativeId : duplicatedAssessmentId}
					duplicate={duplicatedAssessmentId > 0}
					onSave={() => getQualitativeDCE(0, itemsPerPage, sortField, order)}
					onHide={() => {
						setShowModalQual(false);
						setEditedQualitativeId(0);
						setDuplicatedAssessmentId(0);

					}}
					enablePermCard={permBubble}

				/>
			}
			{
				sharedQualId > 0 &&
				<ConfirmationModal
					modalShow={true}
					title={t('ShareAssessment.label')}
					messageText={t('WouldYouLikeToShareItNow.label')}
					callbackModal={(val) => onShareAssessment(val)}
					confirmBtn={t("ShareNow.label")}
					CancelBtn={t("DoItLater.label")}
				/>
			}
		</>
	);
}
QualitativeDCEList.propTypes = {};

export default withTranslation()(QualitativeDCEList);
